import { Car, CarSearch } from "@models/car";
import { buildCarSort, CarSort } from "@features/tickets/api/carsBrowse.utils";
import { useSearchCarsBrowseQuery } from "@features/tickets/api/cars.api";
import { useResourceBrowse } from "@features/tickets/shared/hooks/useResourceBrowse";
import { parseCarsUrlParams, syncCarsUrlParams } from "./carsUrlParams";

export function useCarsBrowse() {
  const browse = useResourceBrowse<CarSearch, Car, CarSort>({
    parseBrowseUrlParams: parseCarsUrlParams,
    syncBrowseUrlParams: syncCarsUrlParams,
    buildSort: buildCarSort,
    useBrowseQuery: useSearchCarsBrowseQuery,
  });

  return {
    carSearchForm: browse.form,
    data: browse.data,
    isLoading: browse.isLoading,
    sortKey: browse.sortKey,
    sortMethod: browse.sortMethod,
    handleSortKeyChanged: browse.handleSortKeyChanged,
    handleSortMethodChanged: browse.handleSortMethodChanged,
    page: browse.page,
    perPage: browse.perPage,
    hasNextPage: browse.hasNextPage,
    hasPrevPage: browse.hasPrevPage,
    handleNextPage: browse.handleNextPage,
    handlePrevPage: browse.handlePrevPage,
    handleRowsPerPageChange: browse.handleRowsPerPageChange,
    reset: browse.reset,
  };
}
